import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";

// `image` and `link` are optional. Cards without an image show `icon` instead,
// and cards without a link show a "Private" note.
export const projectsData = [
      {
        id: 1,
        icon: "bx bx-test-tube",
        title: "Java Unit Test Generator",
        category: "tools",
        description: "A CLI tool that reads Java code and writes unit tests for it. Built on JavaParser and tested on 49 sample models plus open-source Spring Boot projects like spring-petclinic.",
        tags: ["Java", "Maven", "JavaParser"],
      },
      {
        id: 2,
        icon: "bx bx-credit-card-front",
        title: "Spring Boot Integration Libraries",
        category: "backend",
        description: "Plug-and-play PayPal and Stripe libraries for a Spring Boot platform. Add the dependency, set your keys, and it's ready to use.",
        tags: ["Spring Boot", "Stripe", "PayPal"],
      },
      {
        id: 4,
        icon: "bx bx-barcode-reader",
        title: "Phone-as-Scanner",
        category: "backend",
        description: "Use your phone as a wireless barcode scanner. Scan a QR code to pair, and every scan goes straight to the web app.",
        tags: ["Spring Boot", "WebSocket", "Quagga2"],
      },
      {
        id: 5,
        icon: "bx bx-data",
        title: "MySQL Replication Monitor",
        category: "tools",
        description: "Shell scripts that check if replication is healthy across six MySQL servers.",
        tags: ["Bash", "MySQL"],
      },
      {
        id: 6,
        icon: "bx bx-timer",
        title: "MUST DO",
        category: "side projects",
        description: "A small always-on-top task tracker for Windows, with a timer for each task, history and a compact mode.",
        tags: ["C#", "WPF"],
      },
      {
        id: 8,
        image: Work1,
        title: "Ecommerce Web Application",
        category: "side projects",
        description: "E-commerce storefront built with React.",
        tags: ["React"],
        link: "https://main--dust-ecommerce.netlify.app/",
      },
      {
        id: 9,
        image: Work2,
        title: "Simple Movie Application",
        category: "side projects",
        description: "Movie browsing app built with React.",
        tags: ["React"],
        link: "https://dcggutierrez.github.io/movie-app/",
      },
      {
        id: 10,
        image: Work3,
        title: "Monster Rolodex",
        category: "side projects",
        description: "Searchable card list, an early React project.",
        tags: ["React"],
        link: "https://dcggutierrez.github.io/React-MonsterRolodex/",
      },
];

export const projectsNav = [
    { name: 'all' },
    { name: 'backend' },
    { name: 'tools' },
    { name: 'side projects' },
];
